export default __webpack_public_path__ + "static/media/jon-runyan.3c5de5b4.jpg";